module.exports = __webpack_public_path__ + "img/Group1.5b3c31fc.png";